module.exports = __webpack_public_path__ + "img/Inflammation-MELA_GSE185386.074709c9.png";